import MainLayout from '@/layouts/MainLayout.vue'

export default {
  path: '/carbon-asset',
  component: MainLayout,
  redirect: '/carbon-asset/market',
  meta: { module: 'carbonAsset', title: '碳资产管理' },
  children: [
    {
      path: 'market',
      name: 'CarbonAssetMarket',
      component: () => import('@/views/carbon-asset/Market.vue'),
      meta: { title: '市场行情' }
    },
    {
      path: 'register',
      name: 'CarbonAssetRegister',
      component: () => import('@/views/carbon-asset/Register.vue'),
      meta: { title: '资产登记' }
    },
    {
      path: 'statistics',
      name: 'CarbonAssetStatistics',
      component: () => import('@/views/carbon-asset/Statistics.vue'),
      meta: { title: '资产统计分析' }
    },
    {
      path: 'calculation',
      name: 'CarbonAssetCalculation',
      component: () => import('@/views/carbon-asset/Calculation.vue'),
      meta: { title: '配额测算' }
    },
    {
      path: 'quota-warning',
      name: 'CarbonAssetQuotaWarning',
      component: () => import('@/views/carbon-asset/QuotaWarning.vue'),
      meta: { title: '配额预警' }
    }
  ]
}
